import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'business-accounts',
    pathMatch: 'full'
  },
  {
    path: 'business-accounts',
    loadChildren: () => import('./business-accounts-management/business-accounts-management.module').then(m => m.BusinessAccountsManagementModule),
  },
  {
    path: 'connectivity-status',
    loadChildren: () => import('./connectivity-status/connectivity-status.module').then(m => m.ConnectivityStatusModule),
  },
  {
    path: 'notifications',
    loadChildren: () => import('./notifications/notifications.module').then(m => m.NotificationsModule),
  },
  {
    path: 'profile',
    loadChildren: () => import('./profile/profile.module').then(m => m.ProfileModule),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PagesRoutingModule { }
